import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material Components
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';

// Our Components
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { RegistrationConfirmationComponent } from './components/registration_confirmation/registration_confirmation.component';
import { ForgotPasswordComponent } from './components/forgot_password/forgot_password.component';
import { ChangePasswordComponent } from './components/change_password/change_password.component';
import { ProfileComponent } from './components/profile/profile.component';
import { authInterceptorProviders } from './services/auth_intercepter.service';
import { CommonModule } from '@angular/common';
import { errorInterceptorProviders } from './services/error_intercepter.service';
import { AuthGuardService } from './services/auth_guard_service.service';
import { PhoneMaskDirective } from './utils/validators/phone_mask.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { SuccessDialogComponent } from './components/success-dialog/success-dialog.component';
import { MatDividerModule } from '@angular/material/divider';
import { ShoppingComponent } from './components/shopping/shopping.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './store/models/app-state.model';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import {  DigitOnlyDirective } from './utils/validators/digit-only.directive';
import { ProductViewComponent } from './components/product-view/product-view.component';
import { WholeNumberDirective } from './utils/Directives/whole-number-directive.directive';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NotificationsManagementComponent } from './components/notifications-management/notifications-management.component';
import { MatRadioModule } from '@angular/material/radio';
import { SubscriptionManagementComponent } from './components/subscription-management/subscription-management.component';
import { CancelDialogComponent } from './components/subscription-management/cancel-dialog/cancel-dialog.component';
import { ProfilePageComponent } from './components/profile-page/profile-page.component';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({
  declarations: [AppComponent],
  exports: [PhoneMaskDirective,],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatInputModule,
    MatIconModule,
    MatListModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTableModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatGridListModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatRadioModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    MatTabsModule,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    LoginComponent,
    NavbarComponent,
    RegistrationComponent,
    RegistrationConfirmationComponent,
    ProfileComponent,
    HomeComponent,
    PhoneMaskDirective,
    DigitOnlyDirective,
    SuccessDialogComponent,
    ShoppingComponent,
    TermsAndConditionsComponent,
    WholeNumberDirective,
    CheckoutComponent,
    PaymentSuccessComponent,
    FooterComponent,
    HeaderComponent,
    ProductViewComponent,
    NotificationsManagementComponent,
    SubscriptionManagementComponent,
    CancelDialogComponent,
    ProfilePageComponent,
    StoreModule.forRoot(reducers, { metaReducers }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),    
  ],

  providers: [
    authInterceptorProviders,
    errorInterceptorProviders,
    [AuthGuardService],
    provideHttpClient(withInterceptorsFromDi())
  ] })
export class AppModule { }
